import { Container, Grid } from "@mui/material";
import { AssetReportHeader } from "./components/AssetReportHeader";
import { AssetReportScoreDetails } from "./components/AssetReportScoreDetails";
import { AssetReportPolicies } from "./components/AssetReportPolicies";
import { AssetReportAdvisories } from "./components/AssetReportAdvisories";
import { AssetReportVulnerabilities } from "./components/AssetReportVulnerabilities";
import { spacing } from "~/pages/reports/utils/reportsConstants";

export function AssetReport() {
  return (
    <Container sx={{ p: 4 }}>
      <Grid container spacing={spacing[50]}>
        <AssetReportHeader />
        <Grid size={12}>
          <AssetReportScoreDetails />
        </Grid>
        {/* not yet possible */}
        {/* <Grid size={12}>
          <AssetReportRiskFactors />
        </Grid> */}
        <Grid size={12}>
          <AssetReportPolicies />
        </Grid>
        <Grid size={12}>
          <AssetReportAdvisories />
        </Grid>
        <Grid size={12}>
          <AssetReportVulnerabilities />
        </Grid>
      </Grid>
    </Container>
  );
}
